import { render } from "./AbstractForm.vue?vue&type=template&id=3c22bc8a"
import script from "./AbstractForm.vue?vue&type=script&lang=js"
export * from "./AbstractForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__